export default __webpack_public_path__ + "static/media/Chateau.be09a678.png";